import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        errorCodes: [400]
    });

    const completeReturnFiledTask = (ticketId, filer) => {
        let url = `returnfiled/${ticketId}/${filer}`
        return api.put(url, null);
    }

    // Return back a collection of functions
    return {
        completeReturnFiledTask
    }
}

// let's return back our create method as the default.
export default {
    create
}
